import React from 'react';
import { SidebarButton } from 'screens/AssetViewerUI';
import MarkAsDone from './MarkAsDone';
import { jsx as _jsx } from "react/jsx-runtime";
function FullscreenActions() {
  return /*#__PURE__*/_jsx(MarkAsDone, {
    as: SidebarButton
  });
}
export default FullscreenActions;